import React,{Component} from 'react';
import connect from "react-redux/es/connect/connect";
import * as wActs from "../../actions/website-actions";
class AdStepThree extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  getTranslation(key)
  {
    let tStr = "";
    tStr =  this.props.WebPage.Translations[key];
    if(wActs.isNullOrUndefined(tStr)) { tStr = "" }
    return tStr;
  }

  getTranslationReplace(key,reps) {
    let resp = "";
    try {
      resp = this.props.WebPage.Translations[key];
      reps.map((v) => {
        resp = resp.replace(v.Key, v.Value);
      });
    } catch(ex) {}
    return resp;
  }

  render() {
    let ccNme = "";
    let loggedIn = wActs.isLoggedIn(this.props.WebPage);
    let tokens = 0; let euros = 0;
    if(!wActs.isNullOrUndefined(this.props.country)) {
      this.props.Ads.AdCountries.Result.map((v) => {
        if(v.Code === this.props.country) {
          ccNme = v.Name;
        }
      });
    }
    let billers = [];
    if(this.props.Billing.Loaded) {
      let sBillers = this.props.Billing.BillingData.SiteBillers.filter((t) => {return t.Domain === wActs.getSubdomain(document.location.hostname)});
      sBillers.map((v) => {
        let tBill = this.props.Billing.BillingData.Billers.filter((t) => {return t.Id === v.BillerId})[0];
        if(!wActs.isNullOrUndefined(tBill)) {
          if(!tBill.ComingSoon || this.props.WebPage.User.RecordId == 149) {
            billers.push(tBill);
          }
        }
      });
    }

    if(loggedIn) {
      try {
        tokens = this.props.WebPage.Wallet.Tokens;
        euros = this.props.WebPage.Wallet.Amount;
      } catch(exe) {}
    }
    let showToks = wActs.isNullOrUndefined(this.props.WebPage.Settings.PayAdsWithTokens) ? false : this.props.WebPage.Settings.PayAdsWithTokens;

    //{this.getTranslation("dash.xamountorxtokens").replace("{{Tokens}}",this.props.packData.Tokens).replace("{{Amount}}",this.props.packData.Amount)}
    return (
      <React.Fragment>
        <div className="sep"></div>

        <div className="cell x4" style={{minHeight: "120px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.advertisementcountry")}</label>
          {ccNme}
        </div>
        <div className="cell x4" style={{minHeight: "120px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.advertisementsize")}</label>
          {this.props.size}
        </div>
        <div className="cell x4" style={{minHeight: "120px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.startdate")}</label>
          {this.props.startDate}
        </div>
        {/*
        <div className="half left" style={{minHeight: "120px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.targeturl")}</label>
          {this.props.targetUrl}
        </div>
        */}
        <div className="half left" style={{minHeight: "120px"}}>
          <label htmlFor="">{this.getTranslation("dash.description")}</label>
          {this.props.packData.Name} &nbsp; {this.props.packData.Amount}&euro;
        </div>
        <div className="sep m-t-m"></div>
        {!this.props.Billing.Loaded &&
        <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
          <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
        </p>
        }

        {this.props.Billing.Loaded &&
        <React.Fragment>
          <div className="ad-greybox" style={{textAlign: "center", fontSize: "1.5rem"}}>{this.getTranslation("dash.boost.chooseabillingmethod")}</div>
          {billers.map((v,i) => {
            return (
              <div className="billing-option" key={"biller-" + i}>
                <div className="logo"><img src={v.Logo} alt={v.Name} className={v.Name}/></div>
                <div className="payby"><img src={v.MethodImage} alt={v.Name} style={{maxWidth: "100%"}}/></div>
                <div className="text">
                  {v.TranslatedDisplayText.map((tv,ti)=>{
                    return <div key={"trantxt-" + ti} dangerouslySetInnerHTML={{__html:this.getTranslationReplace(tv.Key, tv.Replaces)}}></div>
                  })}
                </div>
                <div className="buybutton">
                  <input type="submit" onClick={(e) => {this.props.handleBillerBuy(e,v.BillerType)}} value={this.getTranslation("page.advertise.buynow")} style={{width: "45%"}}/>
                </div>
                <p style={{margin: "10px auto", textAlign: "center"}} dangerouslySetInnerHTML={{__html: this.getTranslation("page.singup.iagreetotheterms").replace("{{TermsUrl}}","/terms").replace("{{PrivacyUrl}}","/privacy")}}></p>
                {(i !== billers.length-1 || showToks) && <div className="sep m-t-l"></div>}
              </div>
            );
          })}


          {showToks &&
            <React.Fragment>
              <div className="ad-greybox">
                <div className="form-input centered-content" style={{width: "100%", fontSize: "20px"}}>
                  {this.getTranslation("dash.yourhavextokens").replace("{{Tokens}}",tokens)}
                </div>
              </div>
              <div className="billing-credits-submit centered-content" style={{width: "100%"}}>
                <input type="submit" onClick={(e) => {this.props.handlePayByCredits(e,"TOK")}} value={this.getTranslation("dash.paybytokens")}  style={{width: "45%"}} />
              </div>
            </React.Fragment>
          }

        </React.Fragment>

        }

        <div className="sep"></div>
        <div className="clear"></div>

        <div className={`cell x12`} style={{margin: "20px auto"}}>
          <div className="ad-greybox" style={{textAlign: "left", lineHeight: "15px", fontSize: "15px"}} dangerouslySetInnerHTML={{__html: this.getTranslation("page.advertise.networkofsitesheader")}}></div>
        </div>


        <div className="full centered-content">
          <input type="submit" value={this.getTranslation("page.profile.previous")} onClick={(e) => { e.preventDefault(); this.props.handleGoBack(e)}} style={{width: "45%"}}/>
        </div>

        <div className="clear"></div>

        <div className="secure-div">
          <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
        </div>

        <div className="clear"></div>


      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Ads: state.Ads,
    Billing: state.Billing,
    CreateOrder: state.Billing.CreateOrder,
    CheckOrder: state.Billing.CheckOrder
  };
}

export default connect(mapStateToProps)(AdStepThree);




